module.exports = __webpack_public_path__ + "img/img6.13a53b81.png";